// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"bfbae489","798":"c3457fb6","928":"ee433af3","996":"e698b1dd"}[chunkId] + ".css";
};